"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var export_container_button_html_1 = __importDefault(require("@public-templates/export-container-button.html"));
(function (module) {
    module.directive('exportContainerButton', [
        '$window',
        'rsEnvironment',
        'timezoneService',
        'uiPageOrder',
        'metricsService',
        function ($window, env, timezoneService, uiPageOrder, metricsService) {
            return {
                scope: {
                    pages: '='
                },
                templateUrl: export_container_button_html_1.default,
                link: function ($scope) {
                    var STATUS = {
                        DOWNLOAD: 'download',
                        PENDING: 'pending',
                        ERROR: 'error'
                    };
                    // Initial status
                    $scope.status = STATUS.DOWNLOAD;
                    // Add status to the scope so we can use it to compare current status
                    $scope._STATUS = _.cloneDeep(STATUS);
                    $scope.canExportReportToFile = !!((env.get('permissions') || {}).exportReportToFile);
                    $scope.enqueueExport = function () {
                        if (!$scope.canExportReportToFile) {
                            return;
                        }
                        metricsService.downloadReport($scope.pages);
                        var timezone = timezoneService.getTimezone();
                        $scope.status = STATUS.PENDING;
                        $scope.$emit('enqueueExport', {
                            timestamp: (new Date()).getTime(),
                            lang: $window.userLang || 'EN',
                            surveyId: env.get('surveyId'),
                            containerId: env.get('containerId'),
                            containerLastModifiedDate: env.get('containerLastModifiedDate'),
                            fieldSetId: env.get('fieldSetId'),
                            snapshotId: env.get('snapshotId'),
                            pageIds: uiPageOrder.getPageIds($scope.pages),
                            exportType: 'pdf',
                            isPublicReport: true,
                            timeZone: timezone
                        }, function (err) {
                            if (err) {
                                $scope.status = STATUS.ERROR;
                                return;
                            }
                            $scope.status = STATUS.DOWNLOAD;
                        });
                    };
                }
            };
        }
    ]);
})(angular.module('reporting.dashboards'));
